/** @jsx jsx */
/* eslint-disable no-use-before-define */

import React from 'react'
import {
    show,
} from '../twd'
import { jsx } from '@emotion/core'

export default () => {
    // const id = getId()

    return <React.Fragment>
    <div className="dropdown dropdown-right">
        <a href='#'
            data-name="faq"
            className="btn btn-link"
            type="button"
            onClick={() => show('faq')}
        >FAQ</a>
    </div>
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/header/bond-support.js